import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BaseComponent implements OnDestroy {
    private subs: Subscription[] = [];
    private localSubs: Subscription[] = [];

    ngOnDestroy(): void {
        this.subs.map((sub: Subscription) => sub.unsubscribe());
        this.localSubs.map((sub: Subscription) => sub.unsubscribe());
    }

    public destroyLocalSubs(): void {
        this.localSubs.map((sub: Subscription) => sub.unsubscribe());
        this.localSubs = [];
    }

    public set uns(sub: Subscription) {
        this.subs = [...this.subs, sub];
    }

    public set localUns(sub: Subscription) {
        this.localSubs = [...this.localSubs, sub];
    }
}
